<template lang="pug">
div(style="margin-top: -24px;margin-left: -15px;margin-right: -15px;")
  #CotizacionesTemporales
    v-layout(align-start='', justify-start='', row='', fill-height='')
      v-flex(xs12, md12, sm12)
        v-card(style="border-radius:5px;background-color: white;")
          v-card-title(style='padding: 8px !important;').justify-center
            img(src='../assets/logo.png', style='height: auto;width: 140px;')
        v-card(style="border-radius:5px;background-color: black")
          v-card-title(style="padding: 7px;").justify-center
            span.white--text Cotizaciones Temporales

    v-dialog(v-model='dialog', persistent, max-width='800px')
      v-container(style='background-color:white !important;max-width: 800px;')
        v-card-title.justify-center
          span.headline Detalle de Cotización
        v-card-text
          v-container(grid-list-md)
            v-layout(wrap)
              v-flex(xs12, sm6)
                v-text-field(v-model='form.nombreCliente', label='Cliente', readonly, outline)
              v-flex(xs12, sm6)
                v-text-field(v-model='form.telefonoCliente', label='Teléfono', readonly, outline)
              v-flex(xs12, sm6)
                v-text-field(v-model='form.vendedorNombre', label='Vendedor', readonly, outline)
              v-flex(xs12, sm6)
                v-text-field(:value='formatDate(form.fechaCreacion)', label='Fecha', readonly, outline)
              v-flex(xs12)
                v-text-field(v-model='form.observacion', label='Observación', readonly, outline)

              v-flex(xs12)
                v-card(outlined)
                  v-card-title(style='font-size:14px;font-weight:bold;padding:12px') Artículos
                  v-data-table(
                    :headers='headersItems'
                    :items='form.items || []'
                    hide-actions
                    style='font-size:13px;'
                  )
                    template(slot='items', slot-scope='props')
                      td {{ props.item.co_art }}
                      td {{ props.item.art_des }}
                      td {{ props.item.cant }}
                      td US$ {{ formatMonto(props.item.precio) }}
                      td US$ {{ formatMonto(props.item.total) }}

              v-flex(xs12)
                v-divider
              v-flex(xs6)
                strong Total: US$ {{ formatMonto(form.total) }}
              v-flex(xs6, style='text-align:right')
                v-chip(:color='getStatusColor(form.estatus)', dark, small) {{ form.estatus | capitalize }}

              v-flex(xs12, v-if="form.estatus === 'pendiente'")
                v-text-field(v-model='obsActualizacion', label='Observación (opcional)', outline)

        v-card-actions.justify-center
          v-btn(
            v-if="form.estatus === 'pendiente'"
            color='green darken-1'
            dark
            flat
            @click='cambiarEstatus("procesado")'
            :loading='loading'
          ) Marcar procesado
          v-btn(
            v-if="form.estatus === 'pendiente'"
            color='red darken-1'
            dark
            flat
            @click='cambiarEstatus("cancelado")'
            :loading='loading'
          ) Cancelar
          v-btn(flat, @click='close') Cerrar

    v-layout(align-start='', justify-start='', row='', fill-height='')
      v-flex(xs12, style='margin-top: 5px;')
        v-card(style="border-radius: 0px 0px 20px 20px;background-color:black;")
          v-card-title(style="padding: 7px;margin-top: 0px;").justify-center
            span.white--text Lista de Cotizaciones Temporales

        v-layout(style='padding:10px 16px 0;', row, wrap)
          v-flex(xs12, sm4)
            v-select(
              v-model='filtroEstatus'
              :items='opcionesEstatus'
              label='Filtrar por estatus'
              clearable
              outline
              dense
              @change='filtrar'
            )

        v-data-table.elevation-1(
          :headers='headers'
          :items='cotizacionesFiltradas'
          :loading='loading'
          :pagination.sync='pagination'
          style="margin-top: 5px;"
        )
          template(slot='items', slot-scope='props')
            td {{ props.item.nombreCliente }}
            td {{ props.item.telefonoCliente || '—' }}
            td {{ props.item.vendedorNombre || '—' }}
            td {{ (props.item.items || []).length }} artículos
            td US$ {{ formatMonto(props.item.total) }}
            td {{ formatDate(props.item.fechaCreacion) }}
            td
              v-chip(:color='getStatusColor(props.item.estatus)', dark, small) {{ props.item.estatus | capitalize }}
            td
              v-btn.mx-0(icon, @click='verDetalles(props.item)', title='Ver detalles')
                v-icon(color='green') visibility
              v-btn.mx-0(icon, @click='eliminar(props.item._id)', title='Eliminar', :disabled='loading')
                v-icon(color='red') delete_outline
</template>

<script>
import Api from "@/services/methods";
import moment from 'moment';

export default {
  name: "CotizacionesTemporales",
  data: () => ({
    loading: false,
    dialog: false,
    cotizaciones: [],
    filtroEstatus: null,
    obsActualizacion: '',
    opcionesEstatus: ['pendiente', 'procesado', 'cancelado'],
    form: {
      _id: null,
      nombreCliente: '',
      telefonoCliente: '',
      vendedorNombre: '',
      vendedorCodigo: '',
      items: [],
      total: 0,
      subtotal: 0,
      observacion: '',
      estatus: 'pendiente',
      fechaCreacion: null,
    },
    headers: [
      { text: 'Cliente', value: 'nombreCliente' },
      { text: 'Teléfono', value: 'telefonoCliente' },
      { text: 'Vendedor', value: 'vendedorNombre' },
      { text: 'Artículos', sortable: false },
      { text: 'Total', value: 'total' },
      { text: 'Fecha', value: 'fechaCreacion' },
      { text: 'Estatus', value: 'estatus', width: '120px' },
      { text: 'Acciones', sortable: false, width: '100px' },
    ],
    headersItems: [
      { text: 'Código', value: 'co_art' },
      { text: 'Descripción', value: 'art_des' },
      { text: 'Cant.', value: 'cant' },
      { text: 'Precio', value: 'precio' },
      { text: 'Total', value: 'total' },
    ],
    pagination: {
      sortBy: 'fechaCreacion',
      descending: true,
      rowsPerPage: 15,
    },
  }),
  filters: {
    capitalize(value) {
      if (!value) return '';
      return value.charAt(0).toUpperCase() + value.slice(1);
    }
  },
  computed: {
    cotizacionesFiltradas() {
      if (!this.filtroEstatus) return this.cotizaciones;
      return this.cotizaciones.filter(c => c.estatus === this.filtroEstatus);
    }
  },
  created() {
    this.cargar();
  },
  methods: {
    async cargar() {
      try {
        this.loading = true;
        const res = await Api.get('cotizacionesTemporal');
        this.cotizaciones = res.data;
      } catch (e) {
        console.error(e);
        this.$swal('Error', 'No se pudieron cargar las cotizaciones', 'error');
      } finally {
        this.loading = false;
      }
    },
    filtrar() {},
    verDetalles(item) {
      this.form = { ...item };
      this.obsActualizacion = '';
      this.dialog = true;
    },
    async cambiarEstatus(nuevoEstatus) {
      try {
        this.loading = true;
        await Api.put(`cotizacionesTemporal/${this.form._id}/estatus`, {
          estatus: nuevoEstatus,
          observacion: this.obsActualizacion,
        });
        this.$swal('¡Listo!', `Cotización marcada como "${nuevoEstatus}"`, 'success');
        this.close();
        this.cargar();
      } catch (e) {
        console.error(e);
        this.$swal('Error', 'No se pudo actualizar el estatus', 'error');
      } finally {
        this.loading = false;
      }
    },
    async eliminar(id) {
      const confirm = await this.$swal({
        title: '¿Eliminar cotización?',
        text: 'Esta acción no se puede deshacer.',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí, eliminar',
        cancelButtonText: 'Cancelar',
      });
      if (!confirm.value) return;
      try {
        this.loading = true;
        await Api.delete(`cotizacionesTemporal/${id}`);
        this.cargar();
      } catch (e) {
        this.$swal('Error', 'No se pudo eliminar', 'error');
      } finally {
        this.loading = false;
      }
    },
    close() {
      this.dialog = false;
      this.form = {
        _id: null, nombreCliente: '', telefonoCliente: '', vendedorNombre: '',
        vendedorCodigo: '', items: [], total: 0, subtotal: 0,
        observacion: '', estatus: 'pendiente', fechaCreacion: null,
      };
    },
    formatDate(val) {
      if (!val) return '—';
      return moment(val).format('DD/MM/YYYY HH:mm');
    },
    formatMonto(val) {
      if (val == null) return '0.00';
      return parseFloat(val).toFixed(2);
    },
    getStatusColor(estatus) {
      const map = { pendiente: 'orange', procesado: 'green', cancelado: 'red' };
      return map[estatus] || 'grey';
    },
  }
}
</script>
